<template>
  <div :class="['fork-booking-cont', { 'iframe-mode': isIframe }]">
    <div class="resto-infos">
      <div class="resto-name">{{ getAllInfos.restoName }}</div>
      <div class="resto-coords">
        <div class="resto-adresse">{{ getAllInfos.restoAdresse }}</div>
        <div class="resto-tel"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
      </div>
    </div>
    <div class="fork-booking">
      <el-button-group class="booking-milestone" v-if="currentStep !== 4">
        <el-button class="milestone-button date" :class="{ 'active': currentStep >= 0, 'arrow': currentStep === 0 }"
          :type="currentStep === 0 ? 'primary' : 'default'" @click="setCurrentStep(0)">
          <div class="button-content">
            <template v-if="!getCurrentDateShorter || currentStep === 0">
              <i class="el-icon-date"></i>
              Date
            </template>
            <template v-else>
              {{ getCurrentDateShorter }}
            </template>
          </div>
        </el-button>

        <el-button class="milestone-button persons" :class="{ 'active': currentStep >= 1, 'arrow': currentStep === 1 }"
          :disabled="currentStep < 1" :type="currentStep === 1 ? 'primary' : 'default'" @click="setCurrentStep(1)">
          <div class="button-content">
            <i class="el-icon-user-solid"></i>
            {{ getNbCouvert && currentStep > 1 ? getNbCouvert : '' }}
          </div>
        </el-button>
        <el-button class="milestone-button hours" :class="{ 'active': currentStep >= 2, 'arrow': currentStep === 2 }"
          :disabled="currentStep < 2" :type="currentStep === 2 ? 'primary' : 'default'" @click="setCurrentStep(2)">
          <template v-if="!selectedService || currentStep === 2">
            <i class="el-icon-time"></i>
          </template>
          <template v-else>
            <div class="button-content">
              {{ selectedService.hour }}
            </div>
          </template>
        </el-button>
        <el-button class="milestone-button form last" :class="{ 'active': currentStep === 3 }"
          :disabled="currentStep < 3" :type="currentStep === 3 ? 'primary' : 'default'" @click="setCurrentStep(3)">
          <div class="button-content">
            <i class="el-icon-edit"></i>
          </div>
        </el-button>
      </el-button-group>
      <el-divider class="divider mt mb" v-if="currentStep === 1 || currentStep === 2 || currentStep === 4" />

      <h2 v-if="currentStep === 1" class="text-help"><i class="el-icon-user-solid"></i>Nombre de personnes</h2>
      <h2 v-if="currentStep === 2" class="text-help"><i class="el-icon-time"></i>Heure de réservation</h2>
      <h2 v-if="currentStep === 4" class="text-help"><i class="el-icon-circle-check"></i>Confirmation</h2>

      <el-divider class="divider mt" />

      <calendar-custom v-if="currentStep === 0" :checkVisibility="true" />
      <persons-selection v-if="currentStep === 1" />
      <hours-selection v-if="currentStep === 2" />
      <form-fork-booking v-if="currentStep === 3" />
      <confirm-fork-booking v-if="currentStep === 4" />
    </div>
    <div class="powered">
      <a href="https://resa.ninja" target="_blank">
        <span>powered by</span>
        <p>Resa.Ninja</p>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { storeRwg } from '../tools/rwg'
import { injectGtm } from '../tools/gtm'
import CalendarCustom from './forkBooking/CalendarCustom'
import HoursSelection from './forkBooking/HoursSelection'
import PersonsSelection from './forkBooking/PersonsSelection'
import ConfirmForkBooking from './forkBooking/confirm'
import FormForkBooking from './forkBooking/form'

export default {
  name: 'ForkBooking',
  components: { CalendarCustom, HoursSelection, PersonsSelection, FormForkBooking, ConfirmForkBooking },
  computed: {
    ...mapGetters({
      getAllInfos: 'infos/getAllInfos',
      getCurrentDateShorter: 'forkBooking/getCurrentDateShorter',
      getCurrentStep: 'forkBooking/getCurrentStep',
      getSelectedService: 'forkBooking/getSelectedService',
      getNbCouvert: 'forkBooking/getNbCouvert'
    }),
    currentStep() {
      return this.getCurrentStep
    },
    selectedService() {
      return this.getSelectedService
    },
    isIframe() {
      return this.$route.meta.isIframe
    }
  },
  watch: {
    'getAllInfos.googleTagManagerId': {
      immediate: true,
      handler(id) {
        if (id) injectGtm(id)
      }
    }
  },
  created() {
    var r = document.querySelector(':root')

    const defaultColor = {
      primary: '#293b73',
      primarycontrast: '#FFFFFF',
      secondary: '#00cec0',
      secondarycontrast: '#29304D',
      bg: '#FFFFFF',
      bgbody: '#242c45',
      bgbodycontrast: '#FFFFFF',
      textplaceholder: '#AAAAAA',
      text: '#808590',
      grey: '#ecedef',
      border: '#dadce0'
    }

    const colors = {
      primary: this.$route.query.primary ? `#${this.$route.query.primary}` : defaultColor.primary,
      primarycontrast: this.$route.query.primarycontrast ? `#${this.$route.query.primarycontrast}` : defaultColor.primarycontrast,
      secondary: this.$route.query.secondary ? `#${this.$route.query.secondary}` : defaultColor.secondary,
      secondarycontrast: this.$route.query.secondarycontrast ? `#${this.$route.query.secondarycontrast}` : defaultColor.secondarycontrast,
      bg: this.$route.query.bg ? `#${this.$route.query.bg}` : defaultColor.bg,
      bgbody: this.$route.query.bgbody ? `#${this.$route.query.bgbody}` : defaultColor.bgbody,
      bgbodycontrast: this.$route.query.bgbodycontrast ? `#${this.$route.query.bgbodycontrast}` : !this.isIframe ? defaultColor.bgbodycontrast : defaultColor.bgbody,
      textplaceholder: this.$route.query.textplaceholder ? `#${this.$route.query.textplaceholder}` : defaultColor.textplaceholder,
      text: this.$route.query.text ? `#${this.$route.query.text}` : defaultColor.text,
      grey: this.$route.query.grey ? `#${this.$route.query.grey}` : defaultColor.grey,
      border: this.$route.query.border ? `#${this.$route.query.border}` : defaultColor.border
    }

    r.style.setProperty('--color-primary', colors.primary)
    r.style.setProperty('--color-primary-light', `${colors.primary}33`)
    r.style.setProperty('--color-primary-ultra-light', `${colors.primary}11`)
    r.style.setProperty('--color-primary-contrast', colors.primarycontrast)
    r.style.setProperty('--color-secondary', colors.secondary)
    r.style.setProperty('--color-secondary-contrast', colors.secondarycontrast)
    r.style.setProperty('--color-bg', colors.bg)
    r.style.setProperty('--color-bg-body', colors.bgbody)
    r.style.setProperty('--color-bg-body-contrast', colors.bgbodycontrast)
    r.style.setProperty('--color-text-placeholder', colors.textplaceholder)
    r.style.setProperty('--color-text', colors.text)
    r.style.setProperty('--color-text-light', `${colors.text}BB`)
    r.style.setProperty('--color-grey', colors.grey)
    r.style.setProperty('--color-grey-light', `${colors.grey}66`)
    r.style.setProperty('--color-border', colors.border)

    if (this.isIframe) {
      document.body.style.backgroundColor = 'transparent'
    }

    if (this.$router.currentRoute.name === 'google-external') {
      const rwgToken = new URLSearchParams(window.location.search).get('rwg_token') || undefined;

      storeRwg(rwgToken, this.$router.currentRoute.params.id);
    }
  },
  methods: {
    setStep(step) {
      this.setCurrentStep(step)
    },
    ...mapActions({
      setCurrentStep: 'forkBooking/setCurrentStep'
    })
  }
}
</script>

<style lang="scss">
.text-help {
  font-size: 16px;
  text-align: center;
  margin: -4px 0px;

  i {
    margin-right: 8px;
  }
}

.divider {
  margin: 0px;

  &.mt {
    margin-top: 16px;
  }

  &.mb {
    margin-bottom: 16px;
  }
}

.resto-infos {
  margin-top: 8px;

  .resto-name {
    text-align: center;
    color: var(--color-bg-body-contrast);
  }

  .resto-coords {
    font-weight: 100;
    font-size: 14px;
    color: var(--color-bg-body-contrast);

    .resto-adresse,
    .resto-tel {
      text-align: center;
      color: var(--color-bg-body-contrast);

      a {
        color: var(--color-bg-body-contrast);
      }
    }
  }
}

.fork-booking-cont {
  .fork-booking {
    max-width: calc(100%);
    max-height: calc(100%);
    max-height: calc(100% - 35px);
    margin: 0px 0px 32px 0px;
  }

  height: 100%;
  max-height: 100svh;

  &:not(.iframe-mode) {
    background-color: var(--color-bg-body);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .fork-booking {
      max-width: calc(100% - 32px);
      max-height: calc(100% - 32px);
      margin: 8px 16px 32px 16px;
    }
  }
}

.iframe-mode {
  .resto-infos {
    display: none;
  }
}

.powered {
  position: fixed;
  bottom: 0;
  padding: 8px;
  width: 100%;

  a {
    color: var(--color-bg-body-contrast);
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 3px;

    p {
      margin: 0;
      text-decoration: underline;
      font-size: 16px;
    }

    span {
      font-size: 14px;
      text-decoration: none;
      color: var(--color-bg-body-contrast);
      opacity: 0.7;
    }
  }
}

.fork-booking {
  border: 1px solid var(--color-border);
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 36px;
  margin: 0 auto;
  width: 400px;
  height: 630px;
  background-color: var(--color-bg);

  .booking-milestone {
    width: calc(100% - 32px);
    margin: 16px 16px 0 16px;

    .button-content {
      position: relative;
      display: flex;
      justify-content: center;
      gap: 4px;
      z-index: 11;
      width: 100%;
    }

    .milestone-button {
      transition: none;
      padding: 12px 0;
      width: calc(25%);
      height: 40px;
    }

    .date {
      border-radius: 50px 0px 0px 50px;
    }

    .form {
      border-radius: 0px 50px 50px 0px;
    }

    .active:not(.arrow):not(.last) {
      box-shadow: inset -1px 0px #ffffff66;
    }

    .active.arrow.el-button:not(.is-disabled):hover,
    .active.arrow.el-button:not(.is-disabled) {
      z-index: 10;
    }

    .active.arrow:after {
      content: "";
      position: absolute;
      width: 28.284px;
      height: 28.284px;
      border-radius: 0.125rem;
      z-index: 10;
      transform: rotate(45deg);
      background-color: var(--color-primary);
      transform-origin: right top;
      right: calc(-20px);
      top: 50%;
    }
  }

  .calendar-grid,
  .persons-grid,
  .hours-grid-cont {
    .is-disabled {
      span {
        text-decoration: line-through;
      }

      color: var(--color-text-light);
      background-color: var(--color-grey) !important;
      border-color: var(--color-border);
    }
  }

  .el-button {

    &.is-disabled:hover,
    &.is-disabled:focus {
      border-color: var(--color-border);
    }

    background-color: transparent !important;
    border-color: var(--color-border);
  }

  .el-divider {
    background-color: var(--color-border);
  }

  .el-button,
  .el-radio-button {

    &.active,
    .el-radio-button__orig-radio:checked+.el-radio-button__inner {
      color: var(--color-primary-contrast);
      background-color: var(--color-primary) !important;
      border-color: var(--color-primary) !important;
    }

    &:focus:not(.is-disabled):not(.arrow),
    &:hover:not(.is-disabled):not(.arrow) {
      color: var(--color-primary);
      background-color: var(--color-primary-light) !important;
    }

    .el-radio-button__inner:hover {
      color: var(--color-primary);
      background-color: transparent;
      border-color: var(--color-primary-light) !important;
    }

    &.booking-button {
      background-color: var(--color-secondary) !important;
      color: var(--color-secondary-contrast);
    }
  }

  .el-input__inner,
  .el-textarea__inner,
  .el-radio-button__inner {
    background-color: transparent;
    border-color: var(--color-border);
  }

  .el-input__inner::placeholder,
  .el-textarea__inner::placeholder {
    color: var(--color-text-placeholder);
  }

  .el-input.is-active .el-input__inner,
  .el-input__inner:focus,
  .el-button--primary,
  .el-checkbox__input.is-checked .el-checkbox__input,
  .el-textarea__inner:focus {
    border-color: var(--color-primary);
  }

  .el-button--primary {
    background-color: var(--color-primary);
  }

  .el-checkbox__input.is-checked+.el-checkbox__input {
    color: var(---color-primary);
  }

  .el-checkbox__input.is-checked .el-checkbox__input {
    background: var(--color-primary);
  }

  .bookingMessage,
  .form-takeResa-cash,
  .step-hours-label {
    background-color: var(--color-grey);
  }

  .text-help,
  .bookingMessage,
  .el-checkbox,
  .el-button,
  .el-input__inner,
  .el-textarea__inner,
  .el-radio-button__inner,
  .el-radio-button__inner,
  .form-takeResa-cash,
  .step-hours-label,
  .confirmation p {
    color: var(--color-text);
  }

  .weekday {
    color: var(--color-text-light);
  }

  .el-skeleton.is-animated .el-skeleton__item {
    background: linear-gradient(90deg, var(--color-grey) 25%, var(--color-grey-light) 37%, var(--color-grey) 63%);
    background-size: 400% 100%;
  }

  .el-checkbox {
    &__input.is-checked+.el-checkbox__label {
      color: var(--color-primary);
    }

    &__input.is-checked .el-checkbox__inner,
    &__input.is-indeterminate .el-checkbox__inner {
      border-color: var(--color-primary);
      background: var(--color-primary);
    }
  }
}

.el-tooltip__popper {
  background: var(--color-grey) !important;
  color: var(--color-text) !important;

  .popper__arrow {
    display: none;
  }
}
</style>